import { useCallback, useEffect, useState } from 'react';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { UnitMeasureService } from '../../services/unitMeasure/unitMeasureService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage unit measure fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de unidades de medida.
----------------------------------------------------------------------------------------*/

const useUnitsMeasure = () => {

    const { userCan } = usePrivilege();
    const [data, setData] = useState<any[]>([]);

    const fetchUnitsMeasure = useCallback(async () => {
        try {
            if (!userCan('list', 'unit_measure')) return;   
            const service = new UnitMeasureService();
            const response = await service.listForSelect({ limit: 999999 });
            const fetchedData = response.getResponseData();

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; symbol: string; }) => ({
                    value: data.id,
                    label: data.name + " (" + data.symbol + ")"
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching unit measures:', error);
        }
    }, []);

    useEffect(() => {
        fetchUnitsMeasure();
    }, []);

    const getUnitsMeasureList = () => {
        return data;
    };

    return { fetchUnitsMeasure, getUnitsMeasureList };    
}

export default useUnitsMeasure;
